/**
 * HUB-A — Onglets Centre Activité (shell).
 * Équipe : Carlos-only (SEC-01). Caisse/Stock : admin.
 */
export const ACTIVITE_TIMELINE_MVP_LIMIT = 30;
/** HUB-G — max événements timeline overview (merge multi-sources). */
export const ACTIVITE_TIMELINE_OVERVIEW_LIMIT = 50;

export const ACTIVITE_TAB_IDS = {
  OVERVIEW: 'overview',
  VENTES: 'ventes',
  PAIEMENTS: 'paiements',
  CAISSE: 'caisse',
  STOCK: 'stock',
  REPARATIONS: 'reparations',
  EQUIPE: 'equipe',
};

/** @typedef {{ id: string; label: string; adminOnly?: boolean; carlosOnly?: boolean; mobileNav?: boolean }} ActiviteTabDef */

/** @type {ActiviteTabDef[]} */
export const ACTIVITE_TABS_ALL = [
  { id: ACTIVITE_TAB_IDS.OVERVIEW, label: "Vue d'ensemble", mobileNav: true },
  { id: ACTIVITE_TAB_IDS.VENTES, label: 'Ventes', mobileNav: true },
  { id: ACTIVITE_TAB_IDS.PAIEMENTS, label: 'Paiements', mobileNav: true },
  { id: ACTIVITE_TAB_IDS.CAISSE, label: 'Caisse', adminOnly: true },
  { id: ACTIVITE_TAB_IDS.STOCK, label: 'Stock', adminOnly: true },
  { id: ACTIVITE_TAB_IDS.REPARATIONS, label: 'Réparations' },
  { id: ACTIVITE_TAB_IDS.EQUIPE, label: 'Équipe', carlosOnly: true },
];

export function getVisibleActiviteTabs({ isAdmin, isCarlosOnly }) {
  return ACTIVITE_TABS_ALL.filter((tab) => {
    if (tab.carlosOnly && !isCarlosOnly) return false;
    if (tab.adminOnly && !isAdmin) return false;
    return true;
  });
}

export function resolveActiviteTab(tabParam, visibleTabs) {
  const ids = visibleTabs.map((t) => t.id);
  if (tabParam && ids.includes(tabParam)) return tabParam;
  return ids[0] || ACTIVITE_TAB_IDS.OVERVIEW;
}
